<script setup lang="ts">
import { getParsingList } from '@/api/modules/home'

definePage({
  name: 'parsing',
  meta: {
    title: '配售解析',
  },
})

const list = ref([]) as any
const loading = ref(false)
const finished = ref(false)

async function onLoad() {
  try {
    const { status, data } = await getParsingList({
      page: 1,
    })
    if (status === 1) {
      list.value = data.list
      finished.value = data.finished
    }
  }
  catch (error) {
    console.error(error)
  }
  finally {
    loading.value = false
  }
}
</script>

<template>
  <FmPageLayout navbar back class="page bg-[#FFFFFF]">
    <template #navbar-end>
      <FmIcon name="material-symbols:add-circle-outline-rounded" class="text-22px color-[#fff]" />
    </template>

    <van-list
      v-model:loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div v-for="(item, index) in list" :key="index" class="m-7px flex gap-10px bg-[#FFFFFF] p-b-7px p-t-7px" style="border-bottom: 1px solid #e4e5e9;">
        <div class="flex items-start gap-10px" style="flex-direction: column;">
          <div class="van-multi-ellipsis--l2 text-17px font-400 line-height-22px">
            {{ item.title }}
          </div>
          <div class="p-l-6px p-r-6px" style="border: 1px solid #e4e5e9;">
            <span>{{ item.tag }}</span>
            <span class="color-[#E51A2D]">{{ item.tagVal }}</span>
          </div>
          <div class="text-11px color-[#666D7F]">
            {{ item.user }} / {{ item.time }}
          </div>
        </div>
        <img :src="item.img" alt="" class="max-h-102px min-h-72px w-102px">
      </div>
    </van-list>
  </FmPageLayout>
</template>
